import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";

const Spinner = () => {
	const loaderCount = useSelector(({ misc }) => misc.loader.count);
	if (loaderCount > 0) {
		return (
			<div className="flex absolute top-1/2 left-1/2 justify-center">
				<CircularProgress color="secondary" />
			</div>
		);
	}
	return null;
};

export default Spinner;
